"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var defaultCookieOptions = {
    domain: '.cian.ru',
    path: '/',
    secure: true,
};
exports.setCookie = function (name, value, config) {
    var options = Object.assign({}, defaultCookieOptions, config);
    var expires = options.expires;
    var cookieExpires;
    if (expires) {
        if (typeof expires === 'number') {
            var d = new Date();
            cookieExpires = new Date(d.setTime(d.getTime() + expires * 1000)).toUTCString();
        }
        else if (expires instanceof Date) {
            cookieExpires = expires.toUTCString();
        }
    }
    document.cookie =
        // tslint:disable-next-line:prefer-template
        name + "=" + encodeURIComponent(value) + "; " +
            ("path=" + options.path) +
            ("; domain=" + options.domain) +
            (cookieExpires ? "; expires=" + cookieExpires : '') +
            (options.secure ? "; secure" : '');
};
exports.deleteCookie = function (name, config) {
    exports.setCookie(name, '', Object.assign({}, config, {
        expires: -1,
    }));
};



//////////////////
// WEBPACK FOOTER
// ./~/@cian/utils/lib/browser/cookie.js
// module id = 143
// module chunks = 0